"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
import _ from "lodash";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import { APIDataSource } from "@/components/grid/data-source";
let ShopBindVd = class extends Vue {
  constructor() {
    super(...arguments);
    // gridController = new GridController<VirtualdesktopModel>(new APIDataSource("api://base.auth/api/v7/virtual_desktops"));
    // base.auth.pro
    // VD列表 BRIEF
    this.gridController = new GridController(new APIDataSource("api://base.auth.pro/v1/virtual-desktops"));
    this.selectDatas = [];
    this.selectLock = false;
    this.activeName = "first";
    this.searchStr = "";
    this.rows = [];
    this.isDelete = false;
    this.searchByName = _.debounce((searchStr) => {
      if (searchStr !== null && searchStr !== "") {
        this.gridController.query.params = {
          "type": "BRIEF",
          "search": `createdTime=sort=desc;nameOrIp=like='${searchStr}';`
        };
      }
      if (searchStr === null || searchStr === "") {
        this.gridController.query.params = {
          "type": "BRIEF",
          "search": `createdTime=sort=desc;`
        };
      }
      this.gridController.query.current = 1;
      this.gridController.search();
    }, 500);
  }
  created() {
    this.gridController.pagePosition = "dialog";
    this.gridController.query.params = {
      "type": "BRIEF",
      "search": `createdTime=sort=desc;`
    };
    this.gridController.query.current = 1;
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.size = true;
  }
  mounted() {
  }
  selectable(row, index) {
    let _data = this._distributionDialog.getAllNew();
    if (_data.length > 0) {
      for (const item of _data) {
        if (item.id === row.id) {
          return true;
        }
      }
      return false;
    }
    if (_data.length === 0) {
      return true;
    }
    return false;
  }
  open(rows, vdID = "", isDelete) {
    return __async(this, null, function* () {
      this.rows = rows;
      this.searchStr = "";
      this.selectDatas = [];
      this.selectLock = false;
      this.gridController.query.params = {
        "type": "BRIEF",
        "search": `createdTime=sort=desc;`
      };
      this.gridController.query.current = 1;
      yield this.gridController.search();
      this._distributionDialog.open();
      this._distributionDialog.setOptSpan(16, 8);
      if (isDelete) {
        this.isDelete = true;
      } else {
        this.isDelete = false;
      }
      this.$nextTick(() => __async(this, null, function* () {
        if (vdID !== "" && vdID !== null && vdID !== void 0 && this.isDelete === false) {
          try {
            const response = yield API.get(`api://base.auth.pro/v1/virtual-desktops/${vdID}`);
            let vdItem = response.data;
            if (vdItem) {
              this._distributionDialog.add({
                id: vdItem.id,
                label: vdItem.name
              });
              this.checkItem();
            }
          } catch (error) {
            if (error.hasOwnProperty("response")) {
              this.$message.error(error.response.data.errors.datas[0].message);
            }
          }
        }
      }));
    });
  }
  saved(data) {
    return __async(this, null, function* () {
      if (data.length <= 0) {
        this.$message.error(this.$t("shopbindvd.no_selected_data"));
        return;
      }
      let vdId = data[0].id;
      let shopIds = _.map(this.rows, "id");
      try {
        const bind_response = yield API.post(`api://base.auth.pro/v1/virtual-desktops/${vdId}/shops-ebusiness-repeat`, {
          "model": "shop.bind",
          "type": "append",
          "shopIds": shopIds
        });
        if (bind_response.data.datas && bind_response.data.datas.length > 0) {
          let message = "";
          for (const ebusinessItem of bind_response.data.datas) {
            if (ebusinessItem.total !== 0) {
              message += `${this.$t("vdbindshop.bind_shop_confirm_tip", { "num": ebusinessItem.total, "custom": ebusinessItem.ebusinessName })}`;
            }
          }
          if (message !== "") {
            message = message + `${this.$t(`vdbindshop.bind_shop_confirm_bind_shop`)}`;
            try {
              yield this.$confirm(
                message,
                this.$t("vdbindshop.binding_shop_confirm_title"),
                {
                  roundButton: true,
                  cancelButtonText: `${this.$t("vdbindshop.binding_tip_cancel")}`,
                  confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`
                }
              );
            } catch (error) {
              return;
            }
          }
        }
        if (this.isDelete) {
          yield API.post(`api://base.auth.pro/v1/virtual-desktops/${vdId}/shops`, {
            shopIds,
            mode: "APPEND"
          });
          this.$message.success(this.$t("shopbindvd.binding_successful"));
          this._distributionDialog.close();
          this.$emit("refresh");
        } else {
          yield API.post(`api://base.auth.pro/v1/virtual-desktops/${vdId}/shops`, {
            shopIds,
            mode: "APPEND"
          });
          this.$message.success(this.$t("shopbindvd.binding_successful"));
          this._distributionDialog.close();
          this.$emit("refresh");
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      if (this._distributionDialog.getAll().length >= 1 && items.length !== 0 || items.length > 1) {
        this.$message.error(this.$t("shopbindvd.a_store_can_only_bind_one"));
        return;
      }
      this._distributionDialog.syncData(this.gridController.result.datas, items, "id", "name");
    }
  }
  changed(data) {
    this.selectLock = true;
    let rows = _.differenceWith(this.selectDatas, data, (selectData, data2) => selectData.id == data2.id);
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  checkItem() {
    this.selectLock = true;
    let selectDatas = this._distributionDialog.getAll();
    let rows = _.intersectionWith(this.gridController.result.datas, selectDatas, (selectData, data) => selectData.id == data.id);
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    _.debounce(() => {
      this.selectLock = false;
    }, 600);
  }
};
__decorateClass([
  Ref("distributionDialog")
], ShopBindVd.prototype, "_distributionDialog", 2);
__decorateClass([
  Ref("multipleTable")
], ShopBindVd.prototype, "_multipleTable", 2);
ShopBindVd = __decorateClass([
  Component({
    components: {
      UiGrid,
      DistributionDialog
    }
  })
], ShopBindVd);
export {
  ShopBindVd as default
};
